import { useHookstate } from "@hookstate/core";
import { Comic } from "../../../../types";
import { readerDataStore } from "../../../../hookstate/readerDataStore";

export function useComicData() {
  const comicData = useHookstate(readerDataStore.comicData).get({
    noproxy: true,
  });

  const setComicData = (data: Comic) => {
    readerDataStore.comicData.set(data);
  };

  return { comicData, setComicData };
}
